package com.partejar.app.feature.equipe.data

data class EquipeMember(
    val id: Long,
    val userId: Long,
    val name: String,
    val email: String,
    val profileCode: String,
    val profileName: String,
    val professionalCategory: String,
    val selectedProfessionalRegistration: ProfessionalRegistration? = null,
    val active: Boolean
)

data class TeamInviteResult(val link: String, val expiresAt: String)

data class TeamInviteInput(
    val name: String,
    val email: String,
    val profileCode: String,
    val professionalCategory: String
)

data class TeamMemberUpdate(
    val profileCode: String,
    val professionalCategory: String,
    val professionalRegistrationId: Long? = null,
    val active: Boolean
)

data class ProfessionalRegistration(val id: Long, val category: String, val council: String, val number: String, val state: String, val active: Boolean = true) {
    val label get() = "$council-$state $number"
}

interface EquipeDataSource {
    suspend fun list(): List<EquipeMember>
    suspend fun invite(input: TeamInviteInput): TeamInviteResult
    suspend fun update(memberId: Long, update: TeamMemberUpdate): EquipeMember
    suspend fun registrations(memberId: Long): List<ProfessionalRegistration>
}

open class EquipeDataException(message: String? = null, cause: Throwable? = null) : Exception(message, cause)
class EquipeAccessException(message: String = "Você não tem permissão para gerenciar esta equipe.") : EquipeDataException(message)
class EquipeMemberMissingException : EquipeDataException("Esta pessoa não faz mais parte deste espaço.")
class EquipeOperationException(message: String) : EquipeDataException(message)
class EquipeUnavailableException(cause: Throwable? = null) : EquipeDataException("Não foi possível acessar a equipe agora.", cause)
